import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { loadShadows, selectShadow } from 'components/shadow_grid/shadows/store/shadows/actions';

import CreationModal from 'components/shadow_grid/shadows/creation/modal';
import Editor from './editor';
import Header from 'components/shadow_grid/shadows/header';
import LoadingSpinner from 'components/ui/loading_spinner';
import Table from 'components/shadow_grid/shadows/table';

import './styles.scss';

export function ShadowsPage({
  creating,
  emptyState,
  loaded,
  loadShadows,
  selectedShadow,
  selectedGlobalShadow,
  selectGlobalShadow,
  selectShadow,
  setDirty,
  showHeader = true,
  onCreatingChange,
  onListShownChange
}) {
  const [creatingLocally, setCreatingLocally] = React.useState(false);
  const modalOpen = creating === undefined ? creatingLocally : creating;
  const setModalOpen = creating === undefined ? setCreatingLocally : onCreatingChange;

  React.useEffect(() => {
    if (!loaded && !selectedShadow) {
      loadShadows();
    }
  }, [loaded, selectedShadow]);

  React.useEffect(() => {
    if (selectedGlobalShadow === null) {
      selectShadow(null);
    }
  }, [selectedGlobalShadow]);

  const listShown = Boolean(loaded && !selectedShadow);
  React.useEffect(() => {
    onListShownChange?.(listShown);
    return () => onListShownChange?.(false);
  }, [listShown]);

  let content;
  if (selectedShadow) {
    // TODO: This generic shadows index shouldn't know about an external setDirty
    //       At least rename the callback to something like onEditEnd and call it in useEffect above
    //       Or better yet, inject it into the actions/store somehow so the selectShadow(null) action can call it and
    //       these components can all stay dumb
    content = <Editor selectGlobalShadow={selectGlobalShadow} setDirty={setDirty} />;
  } else if (loaded) {
    content = [
      showHeader && <Header key="header" onCreate={() => setModalOpen(true)} />,
      <Table emptyState={emptyState} key="table" selectGlobalShadow={selectGlobalShadow} />
    ];
  } else {
    content = <LoadingSpinner />;
  }

  return (
    <div className="shadows-index d-flex flex-column">
      {content}

      {modalOpen && loaded && <CreationModal show onClose={() => setModalOpen(false)} />}
    </div>
  );
}

ShadowsPage.propTypes = {
  creating: PropTypes.bool,
  emptyState: PropTypes.node,
  loaded: PropTypes.bool,
  loadShadows: PropTypes.func.isRequired,
  selectedGlobalShadow: PropTypes.object,
  selectedShadow: PropTypes.object,
  selectGlobalShadow: PropTypes.func,
  selectShadow: PropTypes.func.isRequired,
  setDirty: PropTypes.func,
  showHeader: PropTypes.bool,
  onCreatingChange: PropTypes.func,
  onListShownChange: PropTypes.func,
};

const mapStateToProps = state => ({
  loaded: state.shadows.loaded,
  selectedShadow: state.shadows.selected,
});

const mapDispatchToProps = {
  loadShadows,
  selectShadow,
};

export default connect(mapStateToProps, mapDispatchToProps)(ShadowsPage);
